import React from "react";
import { images } from "../../assets/index";
export const Footer = () => {
  /**
   * Footer of every page containing mywizard aiops logo and copyright
   * @author Isabel Sprengers
   * @version 1.0
   * @see Used in component: Ec2Management.js, FulfilmentUI.js, App.js, Ssh.js
   */

  var date = new Date();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // marginTop: "5%",
        height: "10%",
      }}
    >
      <div style={{ textAlign: "center", fontSize: "14px", color: "#53575b" }}>
        © 2001-{date.getFullYear()} Accenture. All Rights Reserved. Powered By
        Accenture.
      </div>
      <img
        style={{
          width: "300px",
          position: "absolute",
          transform: "translateY(60%)",
        }}
        src={images.FooterImage}
        alt="Footer_not_found"
      />
    </div>
  );
};
